import styled from "styled-components";
import { devices } from "constants/breakpoints";
import { ReactComponent as AAALogo } from "assets/products/shared/icons/aaa-logo.svg";
import { setRawHtml } from "content/setRawHtml";
import { HeaderContent } from "content/contentSchemas";

const StyledHeader = styled.header`
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;

    background-color: ${(props) => props.theme.colors.background};
    border-bottom: 1px solid ${(props) => props.theme.colors.grey6};

    font-size: ${(props) => props.theme.font.size.text};
`;

const AlignMiddleContainer = styled.div`
    display: flex;
    width: 100%;
    max-width: 1470px;
    align-items: center;
    justify-content: space-between;
    padding-left: ${(props) => props.theme.spacing.padding.large};
    padding-right: ${(props) => props.theme.spacing.padding.large};

    @media ${devices.tablet} {
        padding: ${(props) => props.theme.spacing.padding.small};
    }
`;

const StyledLogo = styled(AAALogo)`
    max-height: 60px;
    width: auto;
`;

const InfoContainer = styled.div`
    display: flex;
    align-items: center;

    @media ${devices.tablet} {
        flex-direction: column;
        text-align: right;
        align-items: end;
    }
`;

const BoldText = styled.p`
    margin: 0;
    color: ${(props) => props.theme.colors.blue};
    font-weight: ${(props) => props.theme.font.weight.bold};
    @media ${devices.tablet} {
        display: flex;
        flex-direction: column;
    }
`;

const MinorText = styled.p`
    @media ${devices.minDesktop} {
        color: ${(props) => props.theme.colors.blue};
    }

    @media ${devices.desktop} {
        display: none;
    }
`;

const Divider = styled.span`
    color: ${(props) => props.theme.colors.red};

    @media ${devices.minTablet} {
        padding-left: ${(props) => props.theme.spacing.padding.xs};
        padding-right: ${(props) => props.theme.spacing.padding.xs};
    }

    @media ${devices.tablet} {
        display: none;
    }
`;

const HelpFlexContainer = styled.div`
    display: flex;
    align-items: center;
    white-space: nowrap;
`;

const HelpText = styled.p`
    margin: 0;
`;

const PhoneNumber = styled.a`
    text-decoration: none;
    color: ${(props) => props.theme.colors.blue};
    font-weight: ${(props) => props.theme.font.weight.bold};
`;

type HeaderProps = {
    content: HeaderContent;
};

const Header = ({ content }: HeaderProps) => {
    const { productName, productNameHtml, headerSubtitleText, headerHelpText, phoneNumberText } = content;

    return (
        <StyledHeader>
            <AlignMiddleContainer>
                <StyledLogo />
                <InfoContainer>
                    {productNameHtml ? <BoldText {...setRawHtml(productNameHtml)} /> : <BoldText>{productName}</BoldText>}
                    <MinorText aria-label="Informational tagline with help and contact information">
                        :&nbsp;{headerSubtitleText}
                    </MinorText>
                    <Divider>|</Divider>
                    <HelpFlexContainer>
                        <HelpText {...setRawHtml(headerHelpText)} />
                        &nbsp;
                        <PhoneNumber href={`tel:${phoneNumberText}`}>{phoneNumberText}</PhoneNumber>
                    </HelpFlexContainer>
                </InfoContainer>
            </AlignMiddleContainer>
        </StyledHeader>
    );
};

export default Header;
